import SessionModalMessage from "./session-modal-message";

export default SessionModalMessage;
